export default {
    root: "https://appab.ir/abfa-mazandaran/api/Auth/test/",
    root2: "https://appab.ir/abfa-mazandaran/api/Auth/",
 /*",
    root: "http://15.11.11.23:2022/api/Auth/test/",*/
    // root: "https://" + window.location.host + "/AbfaCrm/api/Auth/",
    // root: "http://15.11.11.23:2021/api/Auth/test/",
    PublicRoot:"https://appab.ir/abfa-mazandaran",

    storeInstallerInformation: "StoreInstallerInformation",
    requestActivationCode: "RequestActivationCode",
    verifyActivationCode: "VerifyActivationCode",
    registerUser: "RegisterNewUser",
    getAccessToken: "GetAccessToken",
    getBranchInfo: "GetBranchInfo",
    BranchInquiry:"BranchInquiry",
    DeleteBranch:"DeleteBranch",
    //form services
    getUserRequests: "GetUserRequests",
    updateUserRequest: "UpdateUserRequest",
    getSelectsData: "GetSelectsData",
    getVillages: "GetVillages",
    WaterBranchAssignment:'WaterBranchAssignment',
    WasteWaterBranchAssignment:'WasteWaterBranchAssignment',
    ReplyToInquiry:'ReplyToInquiry',
    ChangeAccountType:'ChangeAccountType',
    ChangeSpecifications:'ChangeSpecifications',
    NationalCodeInquiry:'NationalCodeInquiry',
    ChangeUnit:'ChangeUnit',
    ChangeCapacityContractualBranching:'ChangeCapacityContractualBranching',
    ChangeBranchDiameter:'ChangeBranchDiameter',
    MeterSeparation:'SeparatingMeter',
    MoveMeasuringDevices:'MoveMeasuringDevices',
    MeterTest:'MeterTest',
    MeterChange:'MeterChange',
    InstallAdditionalSiphon:'InstallAdditionalSiphon',
    TemporaryDisconnectAndConnectBranch:'TemporaryDisconnectAndConnectBranch',
    CollectOrMergeBranch:'CollectOrMergeBranch',
    MidTermBill:'MidTermBill',
    BillingReview:'BillingReview',
    BillPayment:'BillPayment',
    DeclareMeterConsumption:'DeclareMeterConsumption',
    SeeHistory:'2-17',
    BillingPayment:'2-18',
    Suggestions:'2-19',
    SaleTankerWater:'SaleTankerWater',
    RedirectUser: "RedirectUser?token=",
    RequestWorkFlow: "GetRequestWorkflow?Token=",
    GetDataWorkFlow: "GetDataWorkFlow",
    GetBranchDefaultValues: "GetBranchDefaultValues",
    GetGuideInformation: "GetGuideInformation",
    EditBranchAlias: "EditBranchAlias",
    GetBillTransactions: "GetBillTransactions",
    GetBillHistory: "GetBillHistory",
    GetPaymentHistory: "GetPaymentHistory",
    GetTrackPaymentBills: "GetTrackPaymentBills",
}